export const INTERVIEWERS_ERROR_MESSAGE =
  'Error in fetching interviewers, please try again';

export const INTERVIEWERS_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 409, 422, 500, 502, 503, 504,
];

export const INTERVIEWER_ADDING_ERROR_MESSAGE =
  'Error in adding interviewer, please try again';

export const INTERVIEWER_ADDING_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 409, 422, 500, 502, 503, 504,
];

export const INTERVIEWER_DELETE_ERROR_MESSAGE =
  'Error in removing interviewer, please try again';

export const INTERVIEWER_DELETE_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 409, 422, 500, 502, 503, 504,
];
